import {
	ADD_PRODUCT_CURRENCY,
	UPDATE_PRODUCT_CURRENCY,
	DELETE_PRODUCT_CURRENCY,
	PRODUCT_CURRENCYS,
	ADD_PRODUCT_CURRENCY_ERROR,
	PRODUCT_CURRENCY_DETAILS,
} from "../types/ProductCurrencyType";
import { message } from "antd";

const initialState = {
	list: null,
	currency: null,
};

const productCurrencyReducer = (state = initialState, action) => {
	switch (action.type) {
		case PRODUCT_CURRENCYS:
			return { ...state, list: action.payload };
		case ADD_PRODUCT_CURRENCY:
			if (!Array.isArray(state.list)) {
				state.list = [];
			}
			const list = [...state.list];
			list.push(action.payload);
			return { ...state, list };

		case PRODUCT_CURRENCY_DETAILS:
			return { ...state, currency: action.payload.data };

		case DELETE_PRODUCT_CURRENCY:
			const filtercurrency = state.list.filter(
				(currency) => currency.id !== parseInt(action.payload) && currency
			);

			return { ...state, list: filtercurrency };

		// return {
		//   list: [
		//     ...state.list.filter((sup) => sup.id !== parseInt(action.payload)),
		//   ],
		// };

		case ADD_PRODUCT_CURRENCY_ERROR:
			message.error(action.payload);
			return state;
		default:
			return state;
	}
};

export default productCurrencyReducer;
